export const range = (start: number, stop: number) => {
  const length = stop - start;
  const result = Array(length);
  // eslint-disable-next-line no-plusplus, no-param-reassign

  for (let idx = 0; idx < length; idx++, start++) {
    result[idx] = start;
  }

  return result;
};
